import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { apiFetch } from "../utility/apiFetch.js";

export function useRecipesQuery() {
  return useQuery({
    queryKey: ["recipes"],
    queryFn: () => apiFetch("recipes"),
    staleTime: 60_000,
  });
}

export function useRecipeQuery(id) {
  return useQuery({
    queryKey: ["recipe", id],
    queryFn: () => apiFetch(`recipes/${id}`),
    enabled: !!id,
    staleTime: 60_000,
  });
}

export function useCreateRecipe() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body) => apiFetch("recipes", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["recipes"] }),
  });
}

export function useUpdateRecipe(id) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body) => apiFetch(`recipes/${id}`, {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["recipes"] });
      qc.invalidateQueries({ queryKey: ["recipe", id] });
    },
  });
}

export function useDeleteRecipe() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id) => apiFetch(`recipes/${id}`, { method: "DELETE" }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["recipes"] }),
  });
}

export function useGrowRecipesQuery(growId) {
  return useQuery({
    queryKey: ["grow-recipes", growId],
    queryFn: () => apiFetch(`grows/${growId}/recipes`),
    enabled: !!growId,
    staleTime: 60_000,
  });
}

export function useAddGrowRecipe(growId) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body) => apiFetch(`grows/${growId}/recipes`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["grow-recipes", growId] }),
  });
}

export function useRemoveGrowRecipe(growId) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (recipeId) => apiFetch(`grows/${growId}/recipes/${recipeId}`, { method: "DELETE" }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["grow-recipes", growId] }),
  });
}
